export { default } from './SectionPitch';